import { render, staticRenderFns } from "./ProButton.vue?vue&type=template&id=d30eae5c&scoped=true&"
import script from "./ProButton.vue?vue&type=script&lang=ts&"
export * from "./ProButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProButton.vue?vue&type=style&index=0&id=d30eae5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30eae5c",
  null
  
)

export default component.exports